
import "../../Foundation/stylable/colors.st.css.js";
import "../../Foundation/stylable/typography.st.css.js";
import { classesRuntime, statesRuntime } from "./../../stylable-esm-runtime.js";



var _namespace_ = "wds_1_76_1_BaseCalendar";
var _style_ = /*#__PURE__*/ classesRuntime.bind(null, _namespace_);

export var cssStates = /*#__PURE__*/ statesRuntime.bind(null, _namespace_);
export var style = /*#__PURE__*/ _style_;
export var st = /*#__PURE__*/ _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_76_1_BaseCalendar__root","text-small-thin":"wds_1_76_1_StylableTypography__text-small-thin","text-tiny-thin":"wds_1_76_1_StylableTypography__text-tiny-thin","container":"wds_1_76_1_BaseCalendar__container","months":"wds_1_76_1_BaseCalendar__months","month":"wds_1_76_1_BaseCalendar__month","weekdays":"wds_1_76_1_BaseCalendar__weekdays","weekdaysRow":"wds_1_76_1_BaseCalendar__weekdaysRow","weekday":"wds_1_76_1_BaseCalendar__weekday","body":"wds_1_76_1_BaseCalendar__body","week":"wds_1_76_1_BaseCalendar__week","day":"wds_1_76_1_BaseCalendar__day","dayCircle":"wds_1_76_1_BaseCalendar__dayCircle","dayWrapper":"wds_1_76_1_BaseCalendar__dayWrapper","dayText":"wds_1_76_1_BaseCalendar__dayText","dayIndicationContainer":"wds_1_76_1_BaseCalendar__dayIndicationContainer"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {"rootPadding":"24px","rootBackgroundColor":"var(--wsr-color-D80, #FFFFFF)","dayHoverColor":"var(--wsr-color-50, var(--wsr-color-B50, #EAF7FF))","calendarWidth":"300px","dayBadgeSize":"36px","focusBoxShadowWidth":"3px","focusBoxShadow":"0 0 0 3px var(--wsr-color-F00, #AADBFC)","boxShadow":"0 0 0 3px var(--wsr-color-D80, #FFFFFF) inset"}; 
export var vars = {}; 




